import { useEffect, useRef } from 'react';

import {
  LoanSummaryDrilldownParam,
  TASK_AUDIENCE_COLUMN_KEY,
  TaskAudienceColumnValues,
} from 'constants/loanSummaryDrilldown';
import useQueryFilters from 'hooks/useQueryFilters';
import { parseTaskAudience } from 'utils/loanSummaryDrilldown';

const useTaskAudienceDrilldown = ({ onColumnFiltersChange, availableLabels = [] }) => {
  const { filters, setFilterValue } = useQueryFilters({ filterFields: LoanSummaryDrilldownParam });

  const taskAudience = parseTaskAudience(filters[LoanSummaryDrilldownParam.TASK_AUDIENCE]);
  const isApplied = useRef(false);

  useEffect(() => {
    if (!taskAudience || isApplied.current || !availableLabels.length) {
      return;
    }

    isApplied.current = true;

    const audienceValues = TaskAudienceColumnValues[taskAudience];
    const presentValues = audienceValues.filter(value => availableLabels.includes(value));

    onColumnFiltersChange(TASK_AUDIENCE_COLUMN_KEY, {
      values: presentValues.length ? presentValues : audienceValues,
    });
    setFilterValue(LoanSummaryDrilldownParam.TASK_AUDIENCE, null);
  }, [taskAudience, availableLabels, onColumnFiltersChange, setFilterValue]);
};

export default useTaskAudienceDrilldown;
